import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { SearchesTypes } from '../actions/actions.types'

type SearchesState = ApplicationState['searches']

function searchesReducer(state: SearchesState = new ImmutableMap(), action: IAction): SearchesState {
	switch (action.type) {
		case SearchesTypes.GetSearch.SUCCESS:
			return state.set(action.requestPayload.searchId, action.payload)
	}
	return state
}

export default searchesReducer
